module.exports = __webpack_public_path__ + "img/assist.661bff74.jpeg";